import { 
  ChangeDetectionStrategy, 
  Component, 
  signal,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    RouterModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatProgressSpinner
],
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Login {

  hide = signal(true); // Toggle password visibility
  passwordMinLength = 5;
  form: FormGroup;

  loading = signal(false); // Loading progress bar

  userEmail: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appService: AppService,
    private router: Router,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    document.body.classList.add('white-bg');
  }

  ngOnDestroy() {
    document.body.classList.remove('white-bg');
  }

  storeEmail() {
    this.userEmail = this.form.get('email')?.value;
  }

  login() {
    if (this.form.valid) {

      this.loading.set(true);

      this.authService.login(this.form.value).subscribe({
        next: (response) => {
          const token = response.data.token;
          const user = response.data.user;

          this.authService.setUserToStorage(user);
          this.authService.setToken(token);
          
          this.authService.navigateToDefaultUrl();
        
        },
        error: (error) => {
          this.appService.handleError(error);
          this.loading.set(false);
        },
      });
    } else {
      // console.error('Form is invalid');
    }
  }
}